module.exports = __webpack_public_path__ + "static/assets/0be8e8b354aabf54d1219b86c3cd00fa.png";